import script from "./SensitiveOne.vue?vue&type=script&setup=true&lang=js"
export * from "./SensitiveOne.vue?vue&type=script&setup=true&lang=js"

import "./SensitiveOne.vue?vue&type=style&index=0&id=a582f1b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a582f1b0"]])

export default __exports__